import {HttpLink} from 'apollo-link-http'
import {setContext} from 'apollo-link-context'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {ApolloLink} from 'apollo-link'
import {isAuthenticated} from '@cred/react-auth/utils'
import {getNewClient} from '../'
import getCookieLink from './cookie'

function getSessionLink(cookies, options = {}) {
  const client = getNewClient({
    link: ApolloLink.from([
      getCookieLink(options),
      new HttpLink({uri: options.uri, credentials: 'same-origin'})
    ]),
    cache: new InMemoryCache()
  })

  return setContext(async (req, {headers}) => {
    // Calling isAuthenticated refresh the token and set the authentication cookies properly
    await isAuthenticated(client, cookies)

    return {
      headers: {
        ...headers,
        'session-id': cookies.get('logSessionId')
      }
    }
  })
}

export default getSessionLink
